import { render } from "./ObjectVariations.vue?vue&type=template&id=656c05a3&scoped=true"
import script from "./ObjectVariations.vue?vue&type=script&lang=js"
export * from "./ObjectVariations.vue?vue&type=script&lang=js"

import "./ObjectVariations.vue?vue&type=style&index=0&id=656c05a3&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656c05a3"]])

export default __exports__